import {
  BrowserRouter,
  Routes, // instead of "Switch"
  Route,
} from "react-router-dom";
import React, {
  Component
} from "react";

import Home from "./pages/Home";
import Teorie from "./pages/Teorie";
import WikiContext from "./pages/WikiContext";
import Video from "./pages/Video";
import TaskCompElect from "./components/Task-Comp/Task-Comp-Elect";
import TaskCompEle from "./components/Task-Comp/Task-Comp-Ele";
import TaskCompEl from "./components/Task-Comp/Task-Comp-El";
import ExPrep from "./pages/Exercises";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/teories" element={<WikiContext />} />
        <Route exact path="/videos" element={<Video />} />
        {/* <Route exact path="/exercises" element={<ExPrep />} /> */}
        <Route exact path="/programming" element={<Home />} />
        <Route exact path="/ex-prep" element={<ExPrep />} />
        
        <Route exact path="/problems" element={<Teorie />} />
        <Route exact path="/constant-electric-current-ohm's-laws" element={<TaskCompElect />} />
        <Route exact path="/magnetostatics-problems" element={<TaskCompEle />} />
        <Route exact path="/electromagnetic-induction-phenomenon" element={<TaskCompEl />} /> 
        
      </Routes>
    </BrowserRouter>
  );
};

export default App;
